import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
      globalInterval: [],
      searchHistory: [],
    },
    mutations: {
        //存储搜索记录方法
      //设置搜索记录等于外部传递进来的值
      setSearchHistory(state, search) {
        state.searchHistory = search
        localStorage.searchHistory = search //同步存储搜索记录至localStorage
      },
      // 添加一个定时器
      addIntervalObj(state, funcObj) {
        let keys = Object.keys(funcObj);
        if (keys[0].indexOf(':') < 0) {
          console.log('interval error')
          return
        }
        let funcKey = keys[0].toString().split(':')
        this.commit('removeIntervalObj', funcKey[0])
            let tempInterval = state.globalInterval
            tempInterval[funcKey[0]] = setInterval(funcObj[keys[0]], Number.parseInt(funcKey[1]))
            state.globalInterval = null
            state.globalInterval = tempInterval
        },
        // 删除一个定时器
        removeIntervalObj(state, funcName) {
            let tempInterval = state.globalInterval
            if (!tempInterval[funcName]) {
                return
            }
            clearInterval(tempInterval[funcName])
            tempInterval.splice(tempInterval.findIndex(item => item === funcName), 1)
            state.globalInterval = null
            state.globalInterval = tempInterval
        },
    },
    getters: {
        //获取 搜索记录 方法
        //判断是否有 搜索记录 ,如果没有重新赋值，返回给state的 searchHistory
        getSearchHistory(state) {
            if (state.searchHistory.length<=0) {
                state.searchHistory = localStorage.getItem('searchHistory')
            }
          return state.searchHistory
        },
    },
    // 异步方法
    actions: {
        // eslint-disable-next-line no-unused-vars
        addIntervalObj({commit, state}, funcObj) {
            commit('addIntervalObj', funcObj)
        },
        // eslint-disable-next-line no-unused-vars
        removeIntervalObj({commit, state}, funcName) {
            commit('removeIntervalObj', funcName)
        }
    }
})
